/*
 * @Description: 路由跳转控制中心
*/
import Vue from 'vue'
import Router from 'vue-router'

import aboutRoutes from './about'
import customerRoutes from './customer'
import homeRoutes from './home'
import productRoutes from './product'
import solutionRoutes from './solution'
import errorRoutes from './error'
import xwRoutes from './xw'
import kydhRoutes from './kydh'
import searchRoutes from './search'
Vue.use(Router)

const children = [
  ...aboutRoutes,
  ...customerRoutes,
  ...homeRoutes,
  ...productRoutes,
  ...solutionRoutes,
  ...xwRoutes,
  ...kydhRoutes,
  ...searchRoutes
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: resolve => require(['@/views/Main'], resolve),
      children
    },
    ...errorRoutes
  ]
})

router.beforeEach((to, from, next) => {
    window.scroll(0,0);
    next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js